const API = 'http://adminapi.vstrain.cn';
const APIT = 'http://teacheradminapi.vstrain.cn';
const File = '/file';

export default {
    uploadeditfile: File + '/platform/uploadeditfile', //单个文件上传 适用于封面，banner
    resourceuploadfile: File + '/platform/show/resourceuploadfile', //多个文件上传 适用于资源上传
    metaGetuploadkey: API + '/meta_getuploadkey', //多个文件上传 适用于资源上传

    login: API + '/account_login', //获取用户信息
    metaGetorganizationtype: API + '/meta_getorganizationtype', //获取院校类型
    getresourcetype: API + '/meta_getresourcetype', //获取资源类型
    getcoursetype: API + '/meta_getcoursetype', //获取课程类型 get

    resourceList: API + '/resource_list', //获取资源列表
    resourceAudit: API + '/resource_audit', //单选或多选审核资源列表数据
    resourceDeletet: API + '/resource_delete', //单选或多选删除资源列表数据
    resourceDetails: API + '/resource_details', //资源列表 --查看 get
    resourceAdd: API + '/resource_add', //资源列表 --添加 post
    resourceEdit: API + '/resource_edit', //资源列表 --修改 post
    resourceTranslate: API + '/resource_translate', //资源轻量化 -- post


    categoryList: API + '/category_list', //获取目录列表
    categoryGet: API + '/category_get', //获取目录列表无分页 get
    categoryAudit: API + '/category_audit', //单选或多选审核目录列表数据
    categoryDelete: API + '/category_delete', //单选或多选删除目录列表数据
    categoryCoursedetails: API + '/category_course_details', //目录列表数据 --课程详情
    categoryEdit: API + '/category_edit', //目录列表数据 --课程编辑
    categoryAdd: API + '/category_add', //目录添加 post

    configStatisticsEdit:API +'/config_statistics_edit', //数据统计修改数量 post

    appVersionAdd:API + '/appversion_add', //app版本新增 post
    appVersionList:API + '/appversion_list', //app版本列表 get
    appVersionEdit:API + '/appversion_edit', //app版本修改 post
    appVersionDelete:API + '/appversion_delete', //app版本删除  post

    resourceQuestionImport:API + '/resource_question_import', //试题批量导入 post

    accountPasswordReset:APIT+'/account_password_reset',  //用户修改密码  post
    accountsPasswordReset:API+"/accounts_password_reset",   //批量修改用户密码 POST



  accountBatchimport: API+'/account_batchimport',  //用户管理-账号管理-新增用户  提交接口  post
  accountExist: API+'/account_exist',  //判断账号是否已存在  post
  accountAddressInfo:API+'/account_address_info',  // 用户账号信息查看  post

  userIsReg:APIT+'/user_is_reg',   // 检测手机号是否注册 GET
  regSendSms:APIT+'/reg_send_sms',   // 发送短信验证码 post
  checkSmsCode:APIT+'/check_sms_code',   // 验证短信验证码 GET

	//首页申请
	organization_menu_list:APIT+'/organization_menu_list', //申请列表
	organization_menu_setting:APIT+'/organization_menu_setting', //菜单状态
	organization_menu_audit:APIT+'/organization_menu_audit', //菜单状态
	organization_menu_del:APIT+'/organization_menu_del', //申请删除


  organization_metatitle_list:APIT+'/organization_metatitle_list', //课程设置申请列表
	organization_course_rename_audit:APIT+'/organization_course_rename_audit', //状态审核
	organization_course_rename_del:APIT+'/organization_course_rename_del', //状态审核



	organization_course_rename_list:APIT+'/organization_course_rename_list', //课程设置申请列表
  organization_metatitle_audit:APIT+'/organization_metatitle_audit', //状态审核


  config_organization_course_add_edit:API+'/config_organization_course_add_edit', 
  config_organization_course_list:API+'/config_organization_course_list', 

  config_organization_course_get_list:API+'/config_organization_course_get_list', 
  account_set_schooladmin:APIT+'/account_set_schooladmin'
  
};

